import { FIQAssist } from "../app"
import { Directive, Inject } from "@fiqas/angular-utils";
import { Utils } from "@fiqas/utils";
import { Application } from "../components/application";
@Directive({
    selector: ApplicationSetting.selector,
    module: FIQAssist
})
export class ApplicationSetting {
    public static selector = "applicationSetting";
    public require = "^application"
    constructor() {

    }
    public link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, application:Application): void {
        Utils.forEachProperty(attrs, (p, k) => application.Settings[k] = p, (p, k) => k.indexOf("$") !== 0);
    }
}